export default "__VITE_ASSET__CfHUAdai__"